import { Navigate, useLocation } from "react-router-dom";
import { useSession } from "@/lib/auth-client";
import { LogoMark } from "@/components/logo";
import { DEFAULT_NEXT } from "@/lib/next-path";

// Gates the app behind a verified session. The client hook reads the session
// cookie; the server independently enforces auth on every /api call.
export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { data: session, isPending } = useSession();
  const location = useLocation();

  if (isPending) {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-background">
        <LogoMark size={40} className="animate-pulse" />
      </div>
    );
  }

  if (!session) {
    // Remember where they were headed, so signing in finishes the journey
    // instead of dropping them on the home screen.
    const attempted = `${location.pathname}${location.search}`;
    const to =
      attempted === DEFAULT_NEXT
        ? "/signin"
        : `/signin?next=${encodeURIComponent(attempted)}`;
    return <Navigate to={to} replace />;
  }

  return <>{children}</>;
}
